import { type WButtonProps, WButton } from "@/components/button/WButton.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { DigioSDK } from "@/modules/billing/account_validation/digio/digioLoader.ts";
import { startDigioKycMutation } from "@/modules/billing/account_validation/digio/digioQuery.ts";
import { Trans } from "@lingui/react/macro";
import type { ReactNode } from "react";

type StartDigioValidationButtonProps = Omit<WButtonProps, "action"> & {
    billing_account_id: number;
    try_continue?: boolean;
    digio?: DigioSDK;
    callback: () => void;
};

export function StartDigioValidationButton({
    billing_account_id,
    try_continue = false,
    digio,
    callback,
    ...props
}: StartDigioValidationButtonProps): ReactNode {
    const startMutation = useStandardMutation(startDigioKycMutation);

    const startDigioValidation = async () => {
        if (!digio) return;

        const startResult = await startMutation.mutateAsync({ billing_account_id: billing_account_id, try_continue });
        const { id, customer_identifier, access_token__id: access_token_id } = startResult.data.start!;
        digio.init();
        digio.submit(id, customer_identifier, access_token_id);
        callback();
    };
    const label = try_continue ? <Trans>Continue</Trans> : <Trans>Start here</Trans>;

    return (
        <WButton color="primary" action={startDigioValidation} {...props}>
            {label}
        </WButton>
    );
}
